import { PARAMETROS } from '@/assets/js/appConstants';
 
export const fileSizeValidation = (value, vm) => {
    if (!value) {
        return true;
    }
    let file = value;
    return file.size < PARAMETROS.MAX_TAMANIO_ARCHIVO; // 5MB en bytes
};

export const fileExtensionValidation = value => {
    if (!value) {
        return true;
    }
    let file = value;
    return /^.*\.(jpg|JPG|jpeg|JPEG|png|PNG|pdf|PDF)$/.test(file.name); // condición extensión
};

export const fileExtensionImagesValidation = value => {
    if (!value) {
        return true;
    }
    let file = value;
    return /^.*\.(jpg|JPG|jpeg|JPEG|png|PNG)$/.test(file.name); // condición extensión
};

export const sameDigit = value => {
    return /^(\d)(?!\1+$)\d{8}$/.test(value); // condición mismo dígito
};

export const decimalNumber = value => {
    if (!value) {
        return true;
    }

    return /^\d{1,7}(\.\d{1,2})?$/.test(value); // condición numero entero ( 2 digitos parte decimal)
};


export const countWords = (value) => {
    if (!value) {
        return true;
    }

    var str1 = value.trim().replace(/(^\s*)|(\s*$)/gi,"");
    //convert 2 or more spaces to 1  
    str1 = str1.trim().replace(/[ ]{2,}/gi," ");
    // exclude newline with a start spacing  
    str1 = str1.trim().replace(/\n /,"\n");
    var contador =  str1.split(' ').length;
    
    return contador >= PARAMETROS.TEACHER_METHODOLOGY_MIN_WORDS;  
};
